
export default {
  name: "error",
  layout: 'empty',
  head() {
    return {
      title: "404",
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: "Tirelet araç sahipleri ile araç servislerinin bir araya geldiği platformdur. Aracın için en uygun servisi bulabilirsin."
        },
        { hid: 'keywords', name: 'keywords', content: "servislet, michelin, kormoran, petlas, dunlop, falken, crossclimate, crossclimate 2, primacy4, kampanya, pilot sport 5, crosscilimate+" }
      ],
    }
  },
}
